<!-- Betalingsservice payment receipt (only when gap funding is available) -->
<app-bs-receipt *ngIf="orders && showBsGapfundReceipt"></app-bs-receipt>

<!-- Standard receipt (also shown for BS when gap funding is not available) -->
<div class="receipt" *ngIf="orders && !showBsGapfundReceipt">
    <div class="receipt__bg">
        <app-woop-background></app-woop-background>
    </div>

    <div class="receipt__content">
        <h2 class="receipt__heading">TILLYKKE! Du er med i lodtrækningen fra {{ nextDrawDate | date : "MMMM" }}.</h2>

        <app-countdown-sale-stop class="receipt__countdown"
                                 [isBsWithoutGapfund]="isBsWithoutGapfund"
                                 [showAllCountdownBlocks]="true"
                                 [showNextBSSaleStopDate]="showNextBSSaleStopDate"
                                 [yellowTiles]="true"
                                 [makeFlex]="true"></app-countdown-sale-stop>

        <div class="receipt__receipt">
            <div class="receipt__section">
                <div class="receipt__row">
                    <div>
                        <h3 class="receipt__sub-heading">Kvittering</h3>
                        Kvitteringen er sendt til din e-mail
                    </div>
                    <div class="receipt__purchase-date">
                        {{ dateOfPurchase | date: 'dd. MMM yyyy' }}
                    </div>
                </div>
            </div>

            <app-receipt-strip
                    [paymentPeriod]="paymentPeriod"
                    [showPaymentPeriod]="true"
                    [BSFees]="BSFees"
                    [nextDrawDate]="nextDrawDate"
                    [gapfundDeclined]="gapfundDeclined"></app-receipt-strip>

        </div>

        <div class="receipt__upsell">
            <div class="receipt__upsell-text">
                Lyst til et overblik?
            </div>
            <button tabindex="0" class="cta cta--primary" (click)="goToMyPage()">Gå til min side</button>
        </div>
    </div>
</div>
